<template>
  <div>
    <div class="flex flex-wrap gap-x-4">
      <MoleculesFormsValidatedField class="!-mb-2 tablet:!mb-6 tablet:max-w-[300px]" v-model="form.name" :required="true" :label="$t('Zadejte Vaše jméno')" :placeholder='$t(`Například "Jan Novák"`)' :ref="el => vgForm[0] = el" />
      <MoleculesFormsValidatedField class="tablet:max-w-[300px]" v-model="form.email" :required="true" type="email" :label="$t('Zadejte Váš e-mail')" :placeholder='$t(`Například "jan.novak(at)gmail.com"`)' :ref="el => vgForm[1] = el" />
    </div>
    <MoleculesFormsValidatedField class="!-mt-2" v-model="form.message" :required="true" :multi-line="true" :placeholder="$t('Váš dotaz - pokud je potřeba, specifikujte barvu a velikost.')" :ref="el => vgForm[2] = el" />
    <div class="flex gap-6 flex-wrap items-center justify-end">
      <AtomsFormsCheckbox v-model="agreement" class="leading-5">{{ $t('Souhlasím s') }} <AtomsTextLink :href="cache.getPageUrl(3451)" class="underline" target="_blank">{{ $t('obchodními podmínkami') }}</AtomsTextLink>
      </AtomsFormsCheckbox>
      <MoleculesButtonsButton :arrow-right="true" @click="sendForm">{{ $t('Odeslat dotaz') }}</MoleculesButtonsButton>
    </div>
  </div>
</template>
<script setup>

const cache = useCache();
const i18n = useI18n();
const locale = useLocale().getLocale();

const form = reactive({
  name: '',
  email: '',
  message: '',
});

const agreement = ref(false);

const vgForm = [];

const sendForm = async () => {
  if (await useForm().validateGroup(vgForm)) {
    if (agreement.value) {

      const result = await useApiFetch(`/api/mutations/wareInquiry?languageId=${locale.languageId}`, {
        method: 'POST',
        body: {
          name: form.name,
          email: form.email,
          message: form.message,
          url: document.location.toString(),
        }
      });

      if (result) {
        useMessage().show(i18n.t('Formulář byl odeslán. Odpověď zašleme co nejdříve, děkujeme'));
        useForm().resetForm(vgForm);
      }
      else {
        useMessage().show(i18n.t('Formulář se nepodařilo odeslat. Zkuste to prosím znovu'), 'error', true, false, null, 3000);
      }
    }
    else {
      useMessage().show(i18n.t('Je nutné souhlasit s obchodními podmínkami'), 'error', true, false, null, 3000);
    }
  }
  else {
    useMessage().show(i18n.t('Formulář obsahuje chyby'), 'error', true, false, null, 3000);
  }
};

</script>